export const AUTOMATED_EXAMPLE_MANAGER_ID = 'AEManager';
export const ROW_GROUPING_ID = 'Row Grouping';
export const INTEGRATED_CHARTS_ID = 'Integrated Charts';

export const AG_ROW_SELECTOR = '[role=row]:not(.ag-header-row)';
export const AG_ROW_HOVER_CLASSNAME = 'ag-row-hover';
export const AG_CELL_RANGE_SINGLE_CELL_CLASSNAME = 'ag-cell-range-single-cell';

export const AG_SIDEBAR_BUTTON_LABEL_SELECTOR = '.ag-side-button-label';
export const AG_COLUMN_SELECT_LABEL_SELECTOR = '.ag-column-select-column-label';

export const AG_HEADER_CELL_SELECTOR = '.ag-header-cell';
export const AG_HEADER_CELL_TEXT_SELECTOR = '.ag-header-cell .ag-header-cell-text'; // NOTE: Need header cell, so that filter text is not selected

export const AG_DND_GHOST_SELECTOR = '.ag-dnd-ghost';
export const AG_COLUMN_DROP_SELECTOR = '.ag-column-drop-wrapper';

export const AG_MENU_OPTION_SELECTOR = '.ag-menu-option';
export const AG_MENU_OPTION_TEXT_SELECTOR = '.ag-menu-option-text';
export const AG_MENU_OPTION_ACTIVE_CLASSNAME = 'ag-menu-option-active';
export const AG_MENU_OPTION_DISABLED_CLASSNAME = 'ag-menu-option-disabled';

export const AG_CHART_TOOL_PANEL_BUTTON_SELECTOR = '.ag-chart-tool-panel-button-enable .ag-chart-menu-close';

export const AG_POPUP_SELECTOR = '.ag-popup';
export const AG_POPUP_DIALOG_SELECTOR = '.ag-popup [role="dialog"]';
export const AG_SCROLLABLE_CONTAINER_SELECTOR = '.ag-scrollable-container';

export const AG_CHART_SERIES_GROUP_TITLE_SELECTOR =
    '.ag-chart-settings-mini-wrapper:not(.ag-hidden) .ag-charts-settings-group-title';

export const AG_CHART_TOOL_PANEL_TAB_SELECTOR = '.ag-chart-menu-panel .ag-tab';

export const AG_GROUP_SELECTOR = '.ag-group';
export const AG_GROUP_ITEM_SELECTOR = '.ag-group-item';
export const AG_GROUP_TITLE_BAR_SELECTOR = '.ag-group-title-bar';

export const AG_PICKER_FIELD_SELECTOR = '.ag-picker-field';
export const AG_PICKER_FIELD_WRAPPER_SELECTOR = '.ag-picker-field-wrapper';
export const AG_LABEL_SELECTOR = '.ag-label';
export const AG_SELECT_LIST_ITEM_SELECTOR = '.ag-select-list-item';
export const AG_SLIDER_SELECTOR = '.ag-slider';
export const AG_RANGE_FIELD_INOUT_SELECTOR = '.ag-range-field-input';

// Row group toggle
export const AG_GROUP_CONTRACTED = '.ag-group-contracted';
export const AG_GROUP_EXPANDED = '.ag-group-expanded';

// Speed in pixel/ms
export const DEFAULT_MOUSE_SPEED = 1;

// Class to add to `.ag-dnd-ghost` when created by a script
export const DRAG_COLUMN_GHOST_CLASS = 'automated-example-drag';
